import type { ConditionSlotId } from "../schemas/index.ts";

export const CONDITION_DEFAULT_SLOT_NAME = "~";
export const CONDITION_ROOT_SLOT_ID: ConditionSlotId = { parentId: -1 };
